import { Component, DestroyRef, inject, input, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { provideIcons } from '@ng-icons/core';
import { lucideCheck, lucideX } from '@ng-icons/lucide';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmFieldImports } from '@spartan-ng/helm/field';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { HlmInputImports } from '@spartan-ng/helm/input';
import { toast } from 'ngx-sonner';
import { v7 as uuidv7 } from 'uuid';

import { SidepanelService } from '../../../shared/components/sidepanel/sidepanel.service';
import { ToastrSuccessComponent } from '../../../shared/components/toastr/toastr-success.component';
import { Cartographie } from '../../models/cartographie.model';
import { CartographieStore } from '../../store/cartographie.store';

@Component({
  selector: 'app-creation-carto',
  imports: [FormsModule, HlmIconImports, HlmButtonImports, HlmInputImports, HlmFieldImports],
  providers: [provideIcons({ lucideCheck, lucideX })],
  templateUrl: './creation-carto.component.html',
})
export class CreationCartoComponent implements OnInit, OnDestroy {
  readonly #cartographieStore = inject(CartographieStore);
  readonly #sidepanelService = inject(SidepanelService);
  readonly #destroyRef = inject(DestroyRef);

  readonly cartographie = input.required<Cartographie>();

  nomCarto = '';

  ngOnInit(): void {
    this.#sidepanelService.submit.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(() => this.onSubmit());
  }

  ngOnDestroy(): void {
    toast.dismiss();
  }

  onSubmit(): void {
    const toastrId = uuidv7();
    this.#sidepanelService.loading.set(true);
    this.#cartographieStore.dupliquer({
      id: this.cartographie().id,
      nom: this.nomCarto,
      next: () => {
        toast.custom(ToastrSuccessComponent, {
          componentProps: {
            message: 'La cartographie a bien été dupliquée !',
            id: toastrId,
          },
          id: toastrId,
        });
        this.#sidepanelService.close();
      },
      finalize: () => this.#sidepanelService.loading.set(false),
    });
  }
}
